import { render, staticRenderFns } from "./myInquiryListItem.vue?vue&type=template&id=0d2d21fd&scoped=true&"
import script from "./myInquiryListItem.vue?vue&type=script&lang=js&"
export * from "./myInquiryListItem.vue?vue&type=script&lang=js&"
import style0 from "./myInquiryListItem.vue?vue&type=style&index=0&id=0d2d21fd&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2d21fd",
  null
  
)

export default component.exports